import { createContext, useContext } from 'react'
import { RootStore } from './root-store'

const RootStoreContext = createContext<RootStore | null>(null)

export const RootStoreProvider = RootStoreContext.Provider

/**
 * A hook that containers can use to gain access to stores.
 */
export const useStores = () => {
  const store = useContext(RootStoreContext)
  if (!store) {
    throw new Error('useStores must be used within a <RootStoreProvider />.')
  }
  return store
}
